import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { useService } from 'shared/providers';
import { Brands, Quote } from 'shared/types';

export function useQuote(id: string, brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const { data, isLoading, isFetching } = useQuery<Quote, Error>(['quote', id], () => quoteService.getQuote(id), {
    onError: () => {
      enqueueSnackbar(`Quote ${id} does not exist..`, { variant: 'error' });
      history.push(ROUTES.getSite(brand));
    },
    retry: false,
  });

  return {
    data,
    isLoading,
    isFetching,
  } as const;
}
